export default __webpack_public_path__ + "media/images/about_us/cites-288c58d35714fb5d8db7082fe1655223.png";